import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-eye-close-green",
  "use": "icon-eye-close-green-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye-close-green\">\n<path d=\"M2.87553 5.25C1.81991 6.125 1.16699 7 1.16699 7C1.16699 7 3.77866 10.5 7.00033 10.5C7.39988 10.5 7.79004 10.4462 8.16699 10.3519M5.84293 3.64583C6.21703 3.55297 6.60407 3.5 7.00033 3.5C10.222 3.5 12.8337 7 12.8337 7C12.8337 7 12.1807 7.875 11.1251 8.75\" stroke=\"#00B882\" stroke-width=\"1.16667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M5.4253 6.01453C5.18727 6.27405 5.04199 6.62006 5.04199 6.99998C5.04199 7.80539 5.69492 8.45831 6.50033 8.45831C6.89778 8.45831 7.2581 8.2993 7.52116 8.04143\" stroke=\"#00B882\" stroke-width=\"1.16667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M11.9004 12L1.40039 1.5\" stroke=\"#00B882\" stroke-width=\"1.16667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eye-close-green.svg
// module id = 7Kvk
// module chunks = 1